export default "__VITE_ASSET__C3$N1NWm__"